import React from "react"

import { Link } from "gatsby"

import { Trans } from "gatsby-plugin-react-i18next"

import Spinner from "../_base/Spinner"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import { ChildSelector } from "../../helpers/ChildSelector"

import * as quizStyles from "../../styles/world_championships/Quiz.module.css"

import { AirtableApi } from "../../helpers/AirtableApi"

import { InlineShareButtons } from "sharethis-reactjs"

const NUMBEROFQUESTIONS = 10

const Quiz = props => {
  const { content } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [data, setData] = React.useState(null)
  const [error, setError] = React.useState(false)

  const [scores, setScores] = React.useState(null)

  const [questionNumber, setQuestionNumber] = React.useState(-1)
  const [score, setScore] = React.useState(0)
  const [personalData, setPersonalData] = React.useState(null)

  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await AirtableApi.readRecords(
          process.env.GATSBY_AIRTABLE_API_TOKEN,
          `appoE3nlX6zL5jsX4`,
          `Quiz`,
          `question`,
          `desc`,
        )

        const indexes = Array.from({ length: data.records.length }, (v, k) => k)
        const selected = indexes
          .sort(() => 0.5 - Math.random())
          .slice(0, NUMBEROFQUESTIONS)

        setError(false)
        setData(
          data.records
            .map(r => ({
              question: r.question,
              opts: r.options.split(`\n`),
              answer: r.answer,
            }))
            .filter((r, idx) => selected.includes(idx)),
        )
        setQuestionNumber(0)
      } catch (error) {
        console.error(error)

        setError(true)
        setData([])
        setQuestionNumber(-1)
      }
    }
    if (!data) fetchData()
  }, [data])

  const handleItemChange = evt => {
    let updated = personalData
    updated[evt.target.name] = evt.target.value

    setPersonalData(updated, forceUpdate())
  }

  const handleSubmit = async evt => {
    evt.preventDefault()

    setHasError(false)

    try {
      await AirtableApi.writeRecord(
        process.env.GATSBY_AIRTABLE_API_TOKEN,
        `appoE3nlX6zL5jsX4`,
        `Scores`,
        personalData,
      )

      setHasError(false)
      setSubmitted(true)

      const data = await AirtableApi.readRecords(
        process.env.GATSBY_AIRTABLE_API_TOKEN,
        `appoE3nlX6zL5jsX4`,
        `Scores`,
        `score`,
        `desc`,
      )

      setScores(data.records)
    } catch (error) {
      console.error(error)

      setHasError(true)
    }
  }

  const handleAnswer = opt => {
    if (opt === data[questionNumber].answer) setScore(score + 1)

    if (questionNumber < data.length - 1) setQuestionNumber(questionNumber + 1)
    else
      setPersonalData({
        email: ``,
        name: ``,
        country: ``,
        friend: ``,
        score: score,
        when: new Date().toISOString().slice(0, 10),
      })
  }

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const subtitle = ChildSelector.select(
    content,
    `subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <div className="container-fluid">
      <div className={`row ${quizStyles.wrapper}`}>
        <div className={`col-12`}>
          <div className={`row g-0`}>
            <div className={`col-12 ${quizStyles.heading}`}>
              <h4>{subtitle}</h4>
              <h2>{title}</h2>
            </div>
          </div>

          <div className={`row g-0 ${quizStyles.contentWrapper}`}>
            <div className={`col-lg-9 col-12 ${quizStyles.content}`}>
              <>
                {!data && (
                  <div className={`row g-0`}>
                    <div className={`col-12`}>
                      <Spinner
                        message={`Loading questions, preparing the challenge`}
                      />
                    </div>
                  </div>
                )}
                {error && (
                  <div className={`row g-0`}>
                    <div className={`col-12 ${quizStyles.error}`}>
                      <h5>
                        We couldn't load the quiz now... please try later...
                      </h5>
                    </div>
                  </div>
                )}
                <div className="row g-0">
                  <div className={`col-12 ${quizStyles.gameArea}`}>
                    {data && questionNumber >= 0 && !personalData && (
                      <>
                        <div className={`row g-0 ${quizStyles.row}`}>
                          <div className={`col-12 ${quizStyles.question}`}>
                            <h4>{data[questionNumber].question}</h4>
                          </div>
                        </div>
                        <div className={`row g-0 ${quizStyles.rowOptions}`}>
                          {data[questionNumber].opts.map((opt, indx) => (
                            <div
                              key={indx}
                              className={`col-2 ${quizStyles.option}`}
                            >
                              <button onClick={() => handleAnswer(indx + 1)}>
                                {opt}
                              </button>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="row g-0">
                  <div className={`col-12 ${quizStyles.personalArea}`}>
                    {personalData && !isSubmitted && (
                      <>
                        <div className={`row g-0 ${quizStyles.row}`}>
                          <div className={`col-12 ${quizStyles.score}`}>
                            <h4>Congratulations, you did brilliantly!!!</h4>
                          </div>
                        </div>
                        <div className={`row g-0 ${quizStyles.row}`}>
                          <div
                            className={`col-12 ${quizStyles.personalHeading}`}
                          >
                            <p>
                              Leave us your name and we will add you to the
                              scoreboards.
                            </p>
                          </div>
                        </div>
                        <div className={`row g-0 ${quizStyles.row}`}>
                          <div className={`col-12 ${quizStyles.personalData}`}>
                            <form
                              className={`row ${quizStyles.quizForm}`}
                              onSubmit={handleSubmit}
                            >
                              <div
                                className={`row ${quizStyles.quizFormField}`}
                              >
                                <div className={`col-12`}>
                                  <input
                                    id="email"
                                    type="email"
                                    className="form-control"
                                    placeholder="Email *"
                                    aria-label="email"
                                    name="email"
                                    value={personalData.email}
                                    required
                                    onChange={handleItemChange}
                                  />
                                </div>
                              </div>
                              <div
                                className={`row ${quizStyles.quizFormField}`}
                              >
                                <div className={`col-12`}>
                                  <input
                                    id="name"
                                    type="text"
                                    className="form-control"
                                    placeholder="Name *"
                                    aria-label="name"
                                    name="name"
                                    value={personalData.name}
                                    required
                                    onChange={handleItemChange}
                                  />
                                </div>
                              </div>
                              <div
                                className={`row ${quizStyles.quizFormField}`}
                              >
                                <div className={`col-12`}>
                                  <input
                                    id="country"
                                    type="text"
                                    className="form-control"
                                    placeholder="Country"
                                    aria-label="country"
                                    name="country"
                                    value={personalData.country}
                                    onChange={handleItemChange}
                                  />
                                </div>
                              </div>
                              <div
                                className={`row ${quizStyles.quizFormField}`}
                              >
                                <div className={`col-12`}>
                                  <input
                                    id="friend"
                                    type="email"
                                    className="form-control"
                                    placeholder="Nominate a friend to try the quiz"
                                    aria-label="friend-email"
                                    name="friend"
                                    value={personalData.friend}
                                    onChange={handleItemChange}
                                  />
                                </div>
                              </div>
                              <div className={`row ${quizStyles.formSubmit}`}>
                                <div className={`col ${quizStyles.submit}`}>
                                  <button
                                    type="submit"
                                    className={`${quizStyles.submitButton}`}
                                  >
                                    Submit Quiz
                                  </button>
                                  {hasError && (
                                    <p>
                                      An unexpected error has occurred. Please
                                      confirm all data to be correctly input and
                                      try again...
                                    </p>
                                  )}
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {isSubmitted && (
                  <>
                    <h5>
                      Thank you again for participating. You rocked and scored{" "}
                      {score} points!
                    </h5>
                    {/* <h5>
                      Share the word and invite that one person to do the quiz
                      too.
                    </h5>
                    <InlineShareButtons
                      config={{
                        alignment: "center", // alignment of buttons (left, center, right)
                        color: "social", // set the color of buttons (social, white)
                        enabled: true, // show/hide buttons (true, false)
                        font_size: 16, // font size for the buttons
                        labels: "cta", // button labels (cta, counts, null)
                        language: "en", // which language to use (see LANGUAGES)
                        networks: [
                          // which networks to include (see SHARING NETWORKS)
                          "whatsapp",
                          "linkedin",
                          "email",
                          "facebook",
                        ],
                        padding: 12, // padding within buttons (INTEGER)
                        radius: 4, // the corner radius on each button (INTEGER)
                        show_total: false,
                        size: 40, // the size of each button (INTEGER)

                        // OPTIONAL PARAMETERS

                        min_count: 10, // (threshold for total share count to be displayed)
                        url: "https://www.cubewise.com/2024-tm1-world-championship/", // (defaults to current url)
                        image: "https://cubewisebackend.kinsta.cloud/wp-content/uploads/2024/03/WebImages-12_CROP_WEB.png", // (defaults to og:image or twitter:image)
                        description: "Warm-up quiz for TM1 Championship", // (defaults to og:description or twitter:description)
                        title: "Warm-up quiz for TM1 Championship", // (defaults to og:title or twitter:title)
                        message: "custom email text", // (only for email sharing)
                        subject: "Come and do the warm-up quiz for TM1 Championship!", // (only for email sharing)
                      }}
                    /> 
                    <br />
                    <br />
                    <br /> */}
                    <div class="container px-5">
                      <div className={`row g-0 ${quizStyles.titleRow}`}>
                        <div className={`col-12 ${quizStyles.title}`}>
                          Top Scorers
                        </div>
                      </div>
                      <div className={`row g-0 ${quizStyles.headerRow}`}>
                        <div className={`col-2 ${quizStyles.header}`}>Rank</div>
                        <div className={`col-5 ${quizStyles.header}`}>Name</div>
                        <div className={`col-4 ${quizStyles.header}`}>
                          Country
                        </div>
                        <div className={`col-1 ${quizStyles.header}`}>
                          Score
                        </div>
                      </div>
                      {scores &&
                        scores.slice(0, 3).map((record, index) => (
                          <div
                            key={index}
                            className={`row g-0 ${quizStyles.scoreRow}`}
                          >
                            <div className={`col-2 ${quizStyles.rank}`}>
                              #{index + 1}
                            </div>
                            <div className={`col-5 ${quizStyles.name}`}>
                              {record.name}
                            </div>
                            <div className={`col-4 ${quizStyles.country}`}>
                              {record.country}
                            </div>
                            <div className={`col-1 ${quizStyles.score}`}>
                              {record.score}
                            </div>
                          </div>
                        ))}
                      <div className={`row g-0 ${quizStyles.moreRow}`}>
                        <div className={`col-12 ${quizStyles.more}`}>
                        <Link
                            className={`${quizStyles.moreScoreLink}`}
                            to={`/2024-tm1-world-championship-quiz-ranking`}
                          >
                            <Trans>More Scores</Trans>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            </div>

            <div
              className={`col-lg-3 d-lg-flex d-none ${quizStyles.backgroundContainmentImage}`}
            >
              <WPImage
                holder={content}
                selector={`media-asset`}
                mode={DISPLAY_MODE.normal}
                className={`${quizStyles.backgroundImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Quiz
